<template>
  <div class="microclass">
    <div class="microclass-header">
      <div class="microclass-header-left">
        <img src="@/assets/images/microclass/microclass.png" />
        <ul class="microclass-text" @click="btnColor">
          <li v-for="(item,index) in tablist" :key="index" :class="item.active">{{item.title}}</li>
        </ul>
      </div>
      <div class="microclass-header-right">
        <span class="microclass-right-text">更多</span>
        <img src="@/assets/images/home/arrows.png" />
      </div>
    </div>
    <div class="line"></div>
    <!-- 视频区域 -->
    <div class="microclass-center">
      <div class="microclass-videobox">
        <div class="video-box" v-for="(item,index) in videolist" :key="index">
          <img src="@/assets/images/news-board/u47.svg" />
          <i class="play-btn el-icon-video-play" @click="newsVideo"></i>
          <div class="video-box-footer">
            <div class="microclass-text">
              <div class="microclass-text-left">{{item.title}}</div>
              <span class="microclass-text-right">{{item.text}}</span>
            </div>
            <div class="microclass-msg">
              <span class="microclass-text">
                <span class="microclass-title">阿yi：</span>
                本书较为系统的阐述了行政法和行政诉讼法的基本概念，基本原理和主要.....
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tablist: [
        {
          title: '火爆点评',
          id: 1,
          active: 'active',
        },
      ],
      videolist: [
        {
          id: 1,
          title: '刑侦',
          src: '@/assets/images/news-board/u47.svg',
          text: '警察是国家的重要执法的...',
        },
        {
          id: 2,
          title: '刑侦',
          src: '@/assets/images/news-board/u47.svg',
          text: '让有丰富一线经验和实力...',
        },
        {
          id: 3,
          title: '刑侦',
          src: '@/assets/images/news-board/u47.svg',
          text: '警察是国家的重要执法的...',
        },
        {
          id: 4,
          title: '刑侦',
          src: '@/assets/images/news-board/u47.svg',
          text: '让有丰富一线经验和实力...',
        },
        {
          id: 5,
          title: '刑侦',
          src: '@/assets/images/news-board/u47.svg',
          text: '本课程主要讲解民法和民...',
        },
      ],
    };
  },
  methods: {
    newsVideo() {
      //    console.log('跳转到视频新页面')
    },
    btnColor(ev) {
      //    console.log(ev.target.innerText)
      let title = ev.target.innerText;
      if (title == this.tablist[0].title) {
        this.tablist[0].active = 'active';
        this.tablist[1].active = '';
      } else if (title == this.tablist[1].title) {
        this.tablist[1].active = 'active';
        this.tablist[0].active = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin comment-box {
  display: flex;
  align-items: center;
  line-height: 20px;
  > img {
    width: 15px;
    height: 15px;
    background: rgba(0, 0, 0, 0);
    opacity: 1;
    margin: 0 4px;
  }
  .comment-box-text {
    width: 13px;
    height: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
    opacity: 1;
    margin-right: 1px;
  }
}
.microclass {
  width: 1200px;
  height: 318px;
  background: #ffffff;
  opacity: 1;
  border-radius: 6px;
  .microclass-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    .microclass-header-left {
      display: flex;
      align-items: center;
      .microclass-text {
        display: flex;
        & > li {
          width: 88px;
          height: 22px;
          font-size: 22px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #999999;
          opacity: 1;
          line-height: 22px;
        }
        & > li:first-child {
          margin-left: 10px;
        }
        & > li:not(:first-child) {
          margin-left: 18px;
        }
        .active {
          color: #4876c4;
        }
      }
    }
    .microclass-header-right {
      display: flex;
      align-items: center;
      .microclass-right-text {
        width: 32px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        opacity: 1;
      }
      & > img {
        opacity: 1;
        margin-left: 8px;
        margin-right: 24px;
      }
    }
  }
  .line {
    content: '';
    width: 1200px;
    height: 0px;
    border: 1px solid #cccccc;
    opacity: 1;
  }
  .microclass-center {
    width: 1200px;
    height: 262px;
    background: #ffffff;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .microclass-videobox {
      width: 1156px;
      display: flex;
      justify-content: space-between;
      .video-box {
        width: 222px;
        height: 215px;
        position: relative;
        > img {
          width: 222px;
          height: 136px;
          background: rgba(0, 0, 0, 0);
          opacity: 1;
        }
        .video-box-footer {
          margin-top: 6px;
          height: 58px;
          .microclass-text {
            height: 20px;
            display: flex;
            .microclass-text-left {
              width: 36px;
              height: 20px;
              background: rgba(72, 118, 196, 0.95);
              border: 1px solid #4876c4;
              opacity: 1;
              border-radius: 4px;
              font-size: 13px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 20px;
              text-align: center;
              color: #f8fafc;
            }
            .microclass-text-right {
              width: 166px;
              height: 20px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 20px;
              color: #666666;
              opacity: 1;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-left: 8px;
              overflow: hidden;
            }
          }
          .microclass-msg {
            display: flex;
            width: 222px;
            height: 34px;
            opacity: 1;
            margin-top: 9px;
            .microclass-text {
              width: 222px;
              height: 36px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #919191;
              opacity: 1;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              line-height: 20px;
              .microclass-title {
                width: 34px;
                font-size: 12px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                opacity: 1;
                height: 20px;
              }
            }
          }
        }
      }
    }
  }
}
.play-btn {
  z-index: 1;
  font-size: 27px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -37px;
  &:hover {
    cursor: pointer;
  }
}
</style>